import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { FORGOT_PASSWORD_LINK, HOME_LINK } from "../constants/constants";
import {notifyError, notifySuccess, refreshLocalStorage} from '../helper';
import client from "../api";

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [redirectTo,setRedirectTo] = useState(false);
    const [userNameError,setUserNameError] = useState('');
    const [passwordError,setPasswordError] = useState('');
    const [loading,setLoading] = useState(false);
    const api = client();
    

    const fetchUserInfo = async () => {
        try {
            
            const res = await api.get('/v1/user/me'); 
            if(res.status === 200 || res.status === 201){
                localStorage.setItem('userinfo', JSON.stringify(res.data.data));
                setLoading(false);
                notifySuccess('User logged in successfully',setRedirectTo);                
            }
        } catch(error){
            notifyError(error.message);
            setLoading(false);
        }
    }
    const enter = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            actionLogin();
        }
    }
    const actionLogin = async () => {
        if(!username.length && !password.length){
            setUserNameError('Email Address field cannot be empty.');
            setPasswordError('Password field cannot be empty.');
        } else if(!username.length){
            setUserNameError('Email Address field cannot be empty.');
        } else if(!password.length){
            setPasswordError('Password field cannot be empty.');
        } else if(!(/\S+@\S+\.\S+/.test(username))){
            setUserNameError('Please enter a valid email address.');
        } else {
            try {      
                setLoading(true);      
                const response = await api.post('/v1/user/login',{
                    email:username,
                    password:password
                });                
                if(response.status === 200 || response.status === 201){
                    //notifySuccess('Username and Password is valid');
                    localStorage.setItem('token',response.data.token);
                    fetchUserInfo();
                }
            } catch (error) {
                console.log('error.message',error);
                if(error.status === 400){ notifyError('Bad Request. Not able to login. Please try again'); }
                setLoading(false);
            }
              
                
        }   
    }

    useEffect(()=>{
        const user = localStorage.getItem('userinfo');
        const token = localStorage.getItem('token');
        const tokenOk = token && String(token).trim().length > 0;
        const userOk = user != null && String(user).trim().length > 0;
        if (!tokenOk || !userOk) {
            return;
        }
        (async () => {
            try {
                const res = await api.get('/v1/user/me');
                if (res.status === 200 || res.status === 201) {
                    localStorage.setItem('userinfo', JSON.stringify(res.data.data));
                    setRedirectTo(true);
                }
            } catch {
                refreshLocalStorage();
            }
        })();
    },[]);

    if (redirectTo) {
        const query = new URLSearchParams(window.location.search);
        const redirectUrl = query.get('redirectTo');
        window.location.href = (redirectUrl !== null ? redirectUrl : HOME_LINK);
    }

    return(<>
    <Header/>
    <div className="login-page">
        <div className="login-block">
            <h2>Welcome back! Please sign in.</h2>
            <div className="form-wrap">
                <div className="field-wrap">
                    <label className="label">Email Address</label>
                    <div className="input-wrap">
                        <input 
                            type="text"  
                            name="username" 
                            placeholder="Email Address" 
                            onChange={(e) => {
                                setUsername(e.target.value);
                            }} 
                            onKeyDown={e => enter(e)}
                            onFocus={()=>{
                                setUserNameError('');
                            }}
                            />
                            {userNameError && <span className="validation-error">{userNameError}</span>}
                    </div>
                </div>
                <div className="field-wrap">
                    <label className="label">Password</label>
                    <div className="input-wrap">
                        <input 
                            type="password" 
                            name="password"
                            placeholder="*******" 
                            onChange={(e) => {
                                setPassword(e.target.value);
                            }} 
                            onKeyDown={e => enter(e)}
                            onFocus={()=>{
                                setPasswordError('');
                            }} />
                            {passwordError && <span className="validation-error">{passwordError}</span>}
                    </div>
                    <div className="forget-link">
                        <Link to={FORGOT_PASSWORD_LINK}>Forgot your password?</Link>
                    </div>
                </div>
                <div className="button-wrap center">
                    <button 
                        type="button" 
                        className={loading ? "submit-btn button--loading":"submit-btn"} 
                        disabled={loading}
                        onClick={() => { actionLogin() } }
                        >
                            <span className="button--text">Login</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <Footer/>
    </>);
}

export default LoginPage;